import { render } from "./Tsv.vue?vue&type=template&id=3e59948d&scoped=true"
import script from "./Tsv.vue?vue&type=script&lang=js"
export * from "./Tsv.vue?vue&type=script&lang=js"

import "./Tsv.vue?vue&type=style&index=0&id=3e59948d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e59948d"]])

export default __exports__